import '@babel/polyfill';
import Vue from 'vue'
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader

import { AppMixins } from './Common/helpers/utils';
import store from './Common/Store/mainstore';
import App from './App.vue'
import { i18n } from './Common/plugins/i18n';
import router from './Common/router';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import FlagIcon from 'vue-flag-icon';
import VeeValidate from 'vee-validate';


// App komponente
import ProgressBar from './Common/Components/MyToolbarProgressBar.vue';
import SnackMsg from './Common/Components/SnackMessages.vue';
import AppModal from './Common/Components/AppModal.vue';

// Components teme
import './Common/Components/materialcomponents/components'

// Plugins
import './Common/Components/materialcomponents/plugins'


Vue.config.productionTip = false;
Vue.use(BootstrapVue)
Vue.component('i18', i18n);
Vue.use(FlagIcon);


Vue.use(VeeValidate, { i18n });
Vue.component('SnackMsg', SnackMsg);
Vue.component('AppModal', AppModal);
Vue.component('ProgressBar', ProgressBar);


var moment = require('vue-moment');
Vue.mixin(AppMixins)
Vue.use(moment);


// AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

// Router protector
router.beforeEach((to, from, next) => {
  // ...
  var isLoggedIn = !AppMixins.methods.$hasTokenExpired();
  var requiresAuth = to.meta.requiresAuth;

  if (isLoggedIn || requiresAuth != true) {
    next(true);
  } else {
    // Ako je istekao token, poništimo korisniku podatke i prikažemo login modal
    store.commit('app/SET_LOGIN_MODAL', true);
    store.commit('app/CLEAR_CURRENT_USER_NAME');
    next('/Portal/Security/Login');
  }
})

new Vue({
  store,
  i18n,
  router,
  el: '#app',
  render: h => h(App),
  mounted() {
    
  },
  data: {
  }
})

Vue.config.devtools = true;



// WEBPACK FOOTER //
// ./VueSrc/main.js